import React, { PureComponent } from 'react';
import styles from './index.css';
class PlayButton extends PureComponent {
    render() {
        const { playBtnStatus, playBtnShow, handleClickBtn, openClient } = this.props;
        let playBtnStyle = playBtnStatus === 'play' ? styles.playingBtn : styles.pauseBtn;
        if (playBtnStatus === 'ended') {
            playBtnStyle = styles.replayBtn;
        }
        return (React.createElement("div", { className: `${styles.videoPlayBtn} ${playBtnStyle}`, style: { display: playBtnShow && openClient !== 1 ? 'block' : 'none' }, onClick: handleClickBtn.bind(this), id: "playBtn" }));
    }
}
export default PlayButton;
